/*
 * XYNE Redesign — Product card live-rating hydration
 * --------------------------------------------------
 * Every product card (bestsellers grid, collection grid, etc.) renders TWO
 * sibling rating elements:
 *
 *   1. <div class="jdgm-widget jdgm-preview-badge"> — Judge.me populates
 *      live via their app embed. Hidden by their CSS until hydrated; shows
 *      real stars + count when data lands.
 *   2. <div data-rd-rating-fallback> — our SSR placeholder. Either "★★★★★
 *      4.5 · 2 reviews" (from product.metafields.judgeme.*) or "☆☆☆☆☆ Be
 *      the first to review".
 *
 * This script polls every rating wrap on the page. When a Judge.me badge
 * hydrates with non-zero data, it hides the fallback (so Judge.me's live
 * stars take over). When the badge stays empty (no reviews yet), the
 * fallback stays visible.
 *
 * Self-contained. No dependencies. Loaded sitewide via theme.liquid on
 * rd-redesigned pages.
 */
(function () {
  'use strict';

  function checkWrap(wrap) {
    var badge = wrap.querySelector('.jdgm-prev-badge, .jdgm-preview-badge');
    var fallback = wrap.querySelector('[data-rd-rating-fallback]');
    if (!badge || !fallback) return;

    // Judge.me's hydrated badge will either:
    //   - Have data-average-rating > 0 (real reviews)
    //   - Render visible stars/text inside .jdgm-prev-badge__stars
    //   - Have class jdgm--done-setup AND visible content
    var avg = parseFloat(badge.getAttribute('data-average-rating')) || 0;
    var stars = badge.querySelector('.jdgm-prev-badge__stars');
    var hasStars = stars && stars.children && stars.children.length > 0;
    var visible = window.getComputedStyle(badge).display !== 'none';

    if (avg > 0 && visible && hasStars) {
      fallback.style.display = 'none';
      wrap.classList.add('rd-rating-hydrated');
    } else {
      // Badge is empty / hidden — keep fallback visible
      fallback.style.display = '';
      wrap.classList.remove('rd-rating-hydrated');
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-rd-rating-wrap]').forEach(checkWrap);
  }

  // Watch for Judge.me hydration via mutation observer + interval poll.
  // Judge.me triggers hydration at unpredictable times depending on the
  // widget loader version, so we use both signals.
  function start() {
    syncAll();

    var observer = new MutationObserver(function (mutations) {
      // Cheap throttle — schedule one sync per microtask if any mutation
      // touches a Judge.me badge subtree.
      var hit = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (
          t &&
          (t.className || '').toString &&
          /jdgm-prev|jdgm-preview|jdgm--/.test((t.className || '').toString())
        ) {
          hit = true;
          break;
        }
      }
      if (hit) syncAll();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-average-rating', 'class', 'style']
    });

    // Backup: poll for 20 seconds in case mutation observer misses anything
    var tries = 0;
    var poll = setInterval(function () {
      syncAll();
      if (++tries >= 20) clearInterval(poll);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
